const contactSectionSelector = '[data-contact-form-section]';

const isContactFallbackLink = (link) => {
  const url = new URL(link.href, window.location.href);
  const pathname = url.pathname.replace(/\/+$/, '') || '/';
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

  return url.origin === window.location.origin && pathname === currentPath && url.hash === '#contact';
};

const closeMobileMenu = () => {
  const header = document.querySelector('.header');

  if (!header?.classList.contains('is-open-menu')) return;

  const burgerButton = document.querySelector('.burger-btn');

  if (burgerButton) {
    burgerButton.click();
    return;
  }

  header.classList.remove('is-open-menu');
  document.querySelector('.menu-toggle')?.classList.remove('active');
  document.querySelector('.navbar-nav')?.classList.remove('active');
  document.querySelector('.header-close-wrapper')?.classList.remove('active');
  window.lenis?.start();
};

const scrollToContactSection = (section) => {
  const headerOffset = document.querySelector('.header')?.offsetHeight || 0;
  const scrollOffset = headerOffset + 20;

  if (typeof window.scrollToEl === 'function') {
    window.scrollToEl(`#${section.id}|800|${scrollOffset}`);
    return;
  }

  const top = section.getBoundingClientRect().top + window.scrollY - scrollOffset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
};

if (!document.documentElement.dataset.contactNavigationInitialized) {
  document.documentElement.dataset.contactNavigationInitialized = 'true';

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || (link.target && link.target !== '_self')) return;

    const isFooterContactLink = link.getAttribute('href') === '#footer-contacts' && link.closest('.menu-additional-content');
    if (!isFooterContactLink && !isContactFallbackLink(link)) return;

    const localContactSection = isFooterContactLink
      ? document.getElementById('footer-contacts')
      : document.querySelector(contactSectionSelector);
    if (!localContactSection) return;

    event.preventDefault();
    closeMobileMenu();
    window.requestAnimationFrame(() => scrollToContactSection(localContactSection));
  });
}
